// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"checkboxes_checkboxes__27xtC","container-checkbox":"checkboxes_container-checkbox__3vV2f","checkbox":"checkboxes_checkbox__3RVcp"};